<div
  class="search-form"
  [ngClass]="{ opened }"
  #searchFieldContainer
  (clickOutside)="handleClickOutside($event)"
  >
  <div class="form-container">
    <div class="input-main">
      <button class="transparent" type="button" (click)="backToPrevRoute()">
        <img src="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/left-arrow-icon.svg" alt="search" />
      </button>
      <div class="input-field">
        <input
          id="search-field-input"
          matInput
          #searchInput
          autocomplete="off"
          type="text"
          placeholder="Search..."
          [formControl]="searchField"
          (click)="onFocusSearchField()"
          (keyup.enter)="goToDetails()"
          />
          @if (state === searchState.SEARCHING) {
            <mat-spinner
              diameter="15"
            ></mat-spinner>
          }
        </div>
        @if (searchField.value) {
          <button
            class="transparent clear-btn"
            type="button"
            (click)="clearSearch()"
            >
            <img src="/images/icons/close-icon.svg" alt="" />
          </button>
        }
      </div>
      <button class="primary" type="button" (click)="goToDetails()">
        <img src="https://d1upatzsvnpphr.cloudfront.net/broker/notification_system/media/file/search_icon.svg" alt="" />
      </button>
    </div>
  </div>

  <ng-template #searchDialog>

    @if (!searchResult) {
      <search-suggestion-view></search-suggestion-view>
    }
    @if (searchResult) {
      <search-brief-result
        [searchResult]="searchResult"
        [query]="searchedQuery"
      ></search-brief-result>
    }
  </ng-template>
